// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/password-input","root":"password-input-m__root__gH-Hk text-input-m__root__2yKLO","toggleButton":"password-input-m__toggleButton__3vybc"};